export default __webpack_public_path__ + "static/media/img-bayad.5bc29a98.png";